import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './data-insights.paths';
import { dataInsightsApp } from './data-insights';

export const DataInsightsApp: SpherePlatformApp = {
    APP: dataInsightsApp,
    PATHS
};
